import { DynamicObjectInterface } from '../../../sdk/type';
import { FAIcon, SearchDataStructure, AttributeTypes, Tag, TagStyle, Theme } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { dateTimeToCustomFormat } from '../../../ui/utils';

type IProductBO = {
  [key: string]: DynamicObjectInterface;
};

const campaignSearchOptions: SearchDataStructure[] = [
  {
    name: 'Campaign ID',
    key: 'campaignId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Campaign Name',
    key: 'campaignName',
    type: AttributeTypes.Textbox,
    visibility: false,
  },
  {
    name: 'Campaign Type',
    key: 'campaignType',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: true,
    dataset: [
      {
        key: 'challenge',
        value: 'CHALLENGE',
      },
      {
        key: 'promotion',
        value: 'PROMOTION',
      },
    ],
  },
];

const getCampaignListConfig: GetColumnsType = (
  styles: DynamicObjectInterface,
  translation: DynamicObjectInterface,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'campaignId',
    text: translation('admin.campaignConfig.campaignId'),
    width: 2,
    sortable: true,
    render: (object: IProductBO) => <span>{object.campaignId}</span>,
  },
  {
    key: 'campaignName',
    text: translation('admin.campaignConfig.campaignName'),
    sortable: true,
    width: 6,
    render: (object: IProductBO) => <span>{object.campaignName}</span>,
  },
    {
    key: 'campaignType',
    text: translation('admin.campaignConfig.campaignType'),
    sortable: true,
    width: 3,
    render: (object: IProductBO) => <span>{object.campaignType}</span>,
  },
  {
    key: 'status',
    text: translation('admin.campaignConfig.status'),
    sortable: true,
    width: 3,
    render: (object: IProductBO) => (
      <span>
        <Tag
          theme={object.status === 'ONGOING' ? Theme.SUCCESS : object.status === 'NEW' ? Theme.WARNING : Theme.ERROR}
          style={TagStyle.OUTLINE}
          text={object.status}
        />
      </span>
    ),
  },
  {
    key: 'campaignStart',
    text: translation('admin.campaignConfig.startDate'),
    width: 3,
    sortable: true,
    render: (object: IProductBO) => <span>{dateTimeToCustomFormat(object.campaignStart, 'DD/MM/yyyy')}</span>,
  },
  {
    key: 'campaignEnd',
    text: translation('admin.campaignConfig.endDate'),
    sortable: true,
    width: 3,
    render: (object: IProductBO) => <span>{dateTimeToCustomFormat(object.campaignEnd, 'DD/MM/yyyy')}</span>,
  },

  {
    key: 'actions',
    width: 1,
    text: translation('admin.userSetup.actions'),
    render: (object: IProductBO) => (
      <>
        <FAIcon
          onMouseOver={() => {}}
          iconName={'edit'}
          onClick={e => {
            cb?.onEdit(object.recId);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Edit'}
        />
        {' | '}
        <FAIcon
          iconName={'trash-can'}
          onClick={e => {
            cb?.onClick(object);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Delete'}
        />
      </>
    ),
  },
];

export default getCampaignListConfig;
export { campaignSearchOptions };